import Tools from "./JNSTools";
import GlobalData from "./GlobalData";

class LocalStorageValues {
  constructor(creds, setCreds) {
    this.creds = creds;
    this.setCreds = setCreds;
    this.authString = Tools.getXmlBodyAuthString(creds);
    this.urlString = Tools.getInstanceUrl(creds);
  }

  async findNewProjects() {
    const rawClientProjectList = localStorage.getItem(
      this.creds.company + "|ClientsProjects",
    );

    if (rawClientProjectList) {
      const clientProjectList = JSON.parse(rawClientProjectList);
      const prefReqString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>lastProjectRefresh</name></Preference></Read></request>';
      Tools.fetchPost(prefReqString, this.urlString, "Preference").then(
        (rawPrefRec) => {
          if (rawPrefRec.xml.length > 0) {
            const prefArray = Tools.xmlToArray(rawPrefRec.xml);
            const prefId = prefArray[0].id;
            const prefSetting = prefArray[0].setting;
            const settingDate = new Date(parseInt(prefSetting));
            const estDate = new Date(
              settingDate.getTime() +
                settingDate.getTimezoneOffset() * 60000 -
                1000 * 60 * 60 * 5,
            );

            const requestString =
              this.authString +
              '<Read type="Project" method="equal to" filter="newer-than"><Project><active>1</active></Project><Date><year>' +
              estDate.getFullYear() +
              "</year><month>" +
              (parseInt(estDate.getMonth()) + 1) +
              "</month><day>" +
              estDate.getDate() +
              "</day><hour>" +
              estDate.getHours() +
              "</hour><minute>" +
              estDate.getMinutes() +
              "</minute><second>" +
              estDate.getSeconds() +
              "</second></Date></Read></request>";

            Tools.fetchPost(requestString, this.urlString, "Project").then(
              (rawProjResult) => {
                if (rawProjResult.xml.length > 0) {
                  const projectArray = Tools.xmlToArray(rawProjResult.xml);
                  projectArray.forEach((projRec) => {
                    const projIndex = clientProjectList.findIndex(
                      (elem) => elem.projectId == projRec.id,
                    );

                    if (projIndex >= 0) {
                      clientProjectList.splice(projIndex, 1);
                    }

                    clientProjectList.push({
                      clientproject: projRec.customer_name + ":" + projRec.name,
                      client: projRec.customer_name,
                      project: projRec.name,
                      projectId: projRec.id,
                    });
                  });

                  localStorage.setItem(
                    this.creds.company + "|ClientsProjects",
                    JSON.stringify(clientProjectList),
                  );

                  const today = new Date();
                  const prefUpdateString =
                    this.authString +
                    '<Modify type="Preference"><Preference><id>' +
                    prefId +
                    "</id><setting>" +
                    today.getTime() +
                    "</setting></Preference></Modify></request>";
                  Tools.fetchPost(prefUpdateString, this.urlString);
                }
              },
            );
          }
        },
      );
    }
  }

  async initializeProjectValues(projectObject) {
    const globalDataObject = new GlobalData(this.creds);

    await globalDataObject.populateTable("IssueStage");
    await globalDataObject.populateTable("IssueCategory");
    await globalDataObject.populateTable("IssueSeverity");
    await this.populateReqCategories(projectObject);
    let projRole = "";
    const team = projectObject.oada_project_team__c;
    const teamMembers = team.split(";");
    teamMembers.pop();
    teamMembers.forEach((elem) => {
      const memberInfo = elem.split("|");
      if (memberInfo[1] == this.creds.id) {
        projRole = memberInfo[4];
      }
    });

    this.setCreds({ ...this.creds, projectRole: projRole });
    localStorage.setItem(
      "instanceInfo",
      Tools.encrypt(JSON.stringify({ ...this.creds, projectRole: projRole })),
    );

    const oadaSettingsRaw = localStorage.getItem("oadaSettings");
    if (oadaSettingsRaw) {
      const oadaSettings = JSON.parse(oadaSettingsRaw);
      //if (oadaSettings.etcCalcOption == "futureBooked") {
      const fbhours = await Tools.getFutureBookedHours(
        projectObject.id,
        this.creds,
      );
      //}

      /*
      const readProjectPrefString =
      this.authString +
      '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaProjectSettings</group_name><userid>' +
      projectObject.id +
      "</userid></Preference></Read></request>";

      this.fetchPost(readProjectPrefString, urlString, "Preference").then(
        (projectPrefRecordXML) => {
          if (projectPrefRecordXML.xml.length > 0) {
*/
      // set defaults

      let newSettings = { ...oadaSettings };
      /*if (
        !oadaSettings.thresholds ||
        !oadaSettings.ganttSource ||
        !oadaSettings.ganttDateSource ||
        !oadaSettings.etcCalcOption
      ) {*/
      const requestString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaProjectSettings</group_name><userid>' +
        projectObject.id +
        "</userid></Preference></Read></request>";
      const rawRec = await Tools.fetchPost(
        requestString,
        this.urlString,
        "Preference",
      );
      if (rawRec.xml && rawRec.xml.length > 0) {
        const recArray = Tools.xmlToArray(rawRec.xml);
        recArray.forEach((elem) => {
          newSettings[elem.name] = elem.setting;
        });
      }

      if (!newSettings.thresholds) {
        newSettings.thresholds = { t1: 10, t2: 20 };
      }

      if (!newSettings.ganttSource) {
        newSettings.ganttSource = "Projecttaskassign";
      }

      if (!newSettings.ganttDateSource) {
        newSettings.ganttDateSource = "tasks";
      }

      if (!newSettings.ganttDateEditing) {
        newSettings.ganttDateEditing = true;
      }

      if (!newSettings.etcCalcOption) {
        newSettings.etcCalcOption = "useManual";
      }

      localStorage.setItem("oadaSettings", JSON.stringify(newSettings));

      return true; // just here so the await that calls this will work

      /*} else {
        return true;
      }*/
    }

    /*
    const dashboardConfig = sessionStorage.getItem("dashboardSetup");
    if (!dashboardConfig) {
      const DEFAULT_DASHBOARD_SETUP =
        '[[{"component":"Project Metrics (Row)","id":"02-01-01","size":9},{"component":"Links - Normal (3)","id":"01-01-02","size":3}],[{"component":"Project Team (w/Role)","id":"03-02","size":6},{"component":"Current/Upcoming Tasks","id":"04-01","size":6}]]';
      sessionStorage.setItem("dashboardSetup", DEFAULT_DASHBOARD_SETUP);
    }
*/
  }

  async populateReqCategories(projectObject) {
    const localReqCategories = sessionStorage.getItem(
      "reqCategories" + projectObject.id,
    );

    if (!localReqCategories || localReqCategories == "[]") {
      const reqCatString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>reqCategories</name><userid>' +
        projectObject.id +
        "</userid></Preference></Read></request>";
      Tools.fetchPost(reqCatString, this.urlString, "Preference").then(
        (rawPrefRec) => {
          if (rawPrefRec.xml.length > 0) {
            const prefRec = Tools.xmlToArray(rawPrefRec.xml);
            projectObject.oada_req_categories__c = prefRec[0].setting;
          } else {
            projectObject.oada_req_categories__c = "[]";
          }

          sessionStorage.setItem(
            "reqCategories" + projectObject.id,
            projectObject.oada_req_categories__c,
          );
          return true;
        },
      );
    } else {
      return true;
    }
  }

  async populateProjectSettings() {
    if (this.creds.userType == "generic") {
      const requestString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1000"><Preference><group_name>oadaSettings</group_name></Preference></Read></request>';
      Tools.fetchPost(requestString, this.urlString, "Preference").then(
        (rawPrefRec) => {
          if (rawPrefRec.xml.length > 0) {
            const prefRecArray = Tools.xmlToArray(rawPrefRec.xml);
            console.log("here");
          }
        },
      );
    }
  }

  async initializeGlobalDefaults() {
    //this.initializeIssuePrefix();
    //this.initializeStorageOption();
    this.initializePlannedHoursLocation();
  }

  async initializePlannedHoursLocation() {
    const location = localStorage.getItem(
      this.creds.company + "|PlannedHoursLocation",
    );
    if (!location) {
      const switchString =
        this.authString +
        '<Read type="Company" method="all" limit="1000"></Read></request>';
      Tools.fetchPost(switchString, this.urlString, "Flag").then(
        (rawSwitchRec) => {
          if (rawSwitchRec.xml.length > 0) {
            const switchArray = Tools.xmlToArray(rawSwitchRec.xml);
            const plannedHoursRec = switchArray.find(
              (elem) => elem.name == "project_assign_fixed_hours",
            );
            localStorage.setItem(
              this.creds.company + "|PlannedHoursLocation",
              plannedHoursRec.setting,
            );
          }
        },
      );
    }
  }

  async initializeIssuePrefix() {
    const issuePrefix = localStorage.getItem(
      this.creds.company + "|IssuePrefix",
    );
    if (!issuePrefix) {
      const prefReqString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1"><Preference><name>_form_project_issue_edit_form_prefix</name></Preference></Read></request>';
      Tools.fetchPost(prefReqString, this.urlString, "Preference").then(
        (rawPrefRec) => {
          if (rawPrefRec.xml.length > 0) {
            const prefRecArray = Tools.xmlToArray(rawPrefRec.xml);
            localStorage.setItem(
              this.creds.company + "|IssuePrefix",
              prefRecArray[0].setting,
            );
          }
        },
      );
    }
  }

  async initializeStorageOption() {
    const issuePrefix = localStorage.getItem(
      this.creds.company + "|StorageOption",
    );
    if (!issuePrefix) {
      const prefReqString =
        this.authString +
        '<Read type="Preference" method="equal to" limit="1"><Preference><group_name>oadaSettings</group_name><name>storageOption</name></Preference></Read></request>';
      Tools.fetchPost(prefReqString, this.urlString, "Preference").then(
        (rawPrefRec) => {
          if (rawPrefRec.xml.length > 0) {
            const prefRecArray = Tools.xmlToArray(rawPrefRec.xml);
            localStorage.setItem(
              this.creds.company + "|StorageOption",
              prefRecArray[0].setting,
            );
          }
        },
      );
    }
  }
}
export default LocalStorageValues;
